import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './AdBanner.css';
import emslimImage from '../../../../assets/icons/emslim.png';
import skincareImage from '../../../../assets/icons/skincare.png';
import healthcareImage from '../../../../assets/icons/healthcare.png';

const AdBanner = () => {
  const { t } = useTranslation();
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [index, setIndex] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const containerRef = useRef(null);

  // ✅ Slides avec traductions dynamiques
  const slides = [
    {
      image: emslimImage,
      title: t('adBanner.slides.emslim.title'),
      description: t('adBanner.slides.emslim.description'),
    },
    {
      image: skincareImage,
      title: t('adBanner.slides.healthcare.title'),
      description: t('adBanner.slides.healthcare.description'),
    },
    {
      image: healthcareImage,
      title: t('adBanner.slides.skincare.title'),
      description: t('adBanner.slides.skincare.description'),
    },
    {
      image: '/images/opalia.png',
      title: t('adBanner.slides.opalia.title'),
      description: t('adBanner.slides.opalia.description'),
    },
  ];

  // Auto-rotation every 3 seconds
  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % slides.length);
    }, 3000);
    return () => clearInterval(id);
  }, [slides.length]);

  const handleViewAll = () => {
    // Redirection vers la page des produits ou modal
  };

  // Gestion du glissement tactile et souris
  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - containerRef.current.offsetLeft);
    setScrollLeft(containerRef.current.scrollLeft);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - containerRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    containerRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  const handleTouchStart = (e) => {
    setIsDragging(true);
    setStartX(e.touches[0].pageX - containerRef.current.offsetLeft);
    setScrollLeft(containerRef.current.scrollLeft);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const x = e.touches[0].pageX - containerRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    containerRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  return (
    <div
      className={`ad-banner-container ${isDragging ? 'dragging' : ''}`}
      ref={containerRef}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      role="region"
      aria-label={t('adBanner.ariaLabel')}
      aria-live="polite"
    >
      {/* Slide image */}
      <img
        key={`img-${index}`}
        src={slides[index].image}
        alt={slides[index].title}
        className="ad-image fade"
        draggable={false}
      />

      {/* Slide content */}
      <div key={`content-${index}`} className="ad-content fade">
        <h1 className="main-title">{slides[index].title}</h1>
        <div className="description-container">
          <p className="main-description">{slides[index].description}</p>
        </div>
      </div>

      {/* ✅ Indicateurs de slide (optionnel) */}
      <div className="ad-banner-indicators" aria-label={t('adBanner.slideIndicators')}>
        {slides.map((_, i) => (
          <button
            key={i}
            className={`ad-indicator ${i === index ? 'active' : ''}`}
            onClick={() => setIndex(i)}
            aria-label={t('adBanner.goToSlide', { number: i + 1 })}
            aria-current={i === index ? 'true' : 'false'}
          />
        ))}
      </div>
    </div>
  );
};

export default AdBanner;